import type { UIMessage } from "ai";
import { useEffect, useRef } from "react";

import ChatMessage from "./ChatMessage";
import ChatTypingIndicator from "./ChatTypingIndicator";

interface ChatMessageListProps {
	messages: UIMessage[];
	isThinking: boolean;
	/** What the Tutor is doing while it thinks, when it is known */
	activity?: string | null;
}

const ChatMessageList = ({
	messages,
	isThinking,
	activity,
}: ChatMessageListProps) => {
	const bottomRef = useRef<HTMLDivElement>(null);

	// biome-ignore lint/correctness/useExhaustiveDependencies: scroll only when message count or thinking indicator changes, not on every streaming chunk
	useEffect(() => {
		bottomRef.current?.scrollIntoView({ behavior: "smooth" });
	}, [messages.length, isThinking]);

	return (
		<div className="flex flex-1 flex-col gap-4 overflow-y-auto p-4 pt-6">
			<div className="grow"></div>
			{messages.map((message) => (
				<ChatMessage key={message.id} message={message} />
			))}
			{isThinking && <ChatTypingIndicator label={activity} />}
			<div ref={bottomRef} />
		</div>
	);
};

export default ChatMessageList;
